"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var crypto_1 = __importDefault(require("crypto"));
var utils_1 = require("./utils");
function hash(value, options) {
    if (options === void 0) { options = {}; }
    var parsedValue = utils_1.stringify(value);
    var algorithm = options.algorithm || "sha256";
    var rounds = options.rounds || 1;
    var hash = "" + parsedValue + (options.salt || "");
    for (var i = 0; i < rounds; i++) {
        hash = crypto_1["default"]
            .createHash(algorithm)
            .update(hash)
            .digest("hex");
    }
    return hash;
}
exports.hash = hash;
